import { render, staticRenderFns } from "./FooterRobothon.vue?vue&type=template&id=29bdce20"
import script from "./FooterRobothon.vue?vue&type=script&lang=js"
export * from "./FooterRobothon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports